export default __webpack_public_path__ + "static/filing-4eee9962c0fe3da4d863eee8bf96cfdf.png";